/* eslint-disable @typescript-eslint/camelcase */
import { BlockedPeriodsProps } from 'modules/clients/interfaces';

export const initial: BlockedPeriodsProps[] = [
  {
    weekdays: [],
    start_restriction_at: '20:00:00',
    stop_restriction_at: '06:00:00',
    timezone: 'America/Sao_Paulo',
  },
  {
    weekdays: [],
    start_restriction_at: '20:00:00',
    stop_restriction_at: '06:00:00',
    timezone: 'America/Sao_Paulo',
  },
];
